/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable no-console */
import { Toast } from '@hb/coffee';
import { WindowWithCallNative, Response, BridgeCallbackType } from './types';

const callbackMap = new Map<string, BridgeCallbackType>();
const mannualErrorMap = new Map<string, boolean>();

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const pkg = require('@/../package.json');

let callbackIdSymbol = 0;

const callbackDefinedByHBridge = (window as WindowWithCallNative).callBack;

(window as WindowWithCallNative).callBack = (data: Response): void => {
  // 判断是否存在
  if (typeof callbackDefinedByHBridge === 'function') {
    callbackDefinedByHBridge(data);
  }

  const callback = callbackMap.get(data.callbackId);

  const isMannualError = mannualErrorMap.get(data.callbackId);

  if (callback) {
    if (data.code === 0) {
      if (callback.resolve) {
        callback.resolve(data.data);
      }
    } else {
      if (!isMannualError) {
        if (data.msg || data.errorMsg) {
          Toast(data.msg || data.errorMsg as string);
        } else {
          console.log('未知原因');
          // throw new Error('未知原因');
        }
      }

      if (callback.reject) {
        callback.reject(data.msg);
      }
    }

    callbackMap.delete(data.callbackId);
  }
};

export const callNative = <T = unknown>({
  classMap,
  method,
  params,
  mannualError,
}: {
  classMap: string;
  method: string;
  params?: unknown;
  mannualError?: boolean;
}): Promise<T> => new Promise((resolve: PromiseResolve<T>, reject: PromiseReject) => {
    try {
      callbackIdSymbol += 1;

      const callbackId = String(`${String(pkg.name)}${callbackIdSymbol}`);

      callbackMap.set(callbackId, {
        resolve: resolve as PromiseResolve,
        reject,
      });

      if (mannualError) {
        mannualErrorMap.set(callbackId, true);
      }

      const data = {
        classMap,
        method,
        params: params ? JSON.stringify(params) : '',
        callbackId,
      };

      const dataJSON = JSON.stringify(data);

      if ((window as WindowWithCallNative).AppFunctions) {
      // Android
        (window as WindowWithCallNative).AppFunctions.callNative(dataJSON);
      } else if (
        (window as WindowWithCallNative).webkit
        && (window as WindowWithCallNative).webkit.messageHandlers
      ) {
      // iOS
        (window as WindowWithCallNative).webkit.messageHandlers.callNative.postMessage(
          dataJSON,
        );
      } else {
      // 兼容本地浏览器调试场景
        resolve({} as T);
      }
    } catch (e) {
      const input = {
        classMap,
        method,
        params,
        mannualError,
      };

      if (!mannualError) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        Toast(
          `Native方法启动失败：${JSON.stringify(input)} -> ${JSON.stringify(e)}`,
        );
      }

      reject(e);
    }
  });
